import './Map.css';

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import FPOImage from '../../components/FPOImage';
import Menu from '../../components/HamburgerMenu';
import FPO_IMAGE from './Map_Fullscreen_2x.png';

import useSession from '../../hooks/useSession';
import { getWithAuth } from '../../utils/api';
import { LANDING_PAGES } from '../../utils/constants';

const FPO_OUTLINE = false;

let NUM_PARTNERS = 0;
const PARTNER_ACTIVITY_MAP = LANDING_PAGES
  .filter(page => page.id.startsWith('Booth'))
  .reduce((m, page) => {
    m[page.activity] = true;
    NUM_PARTNERS += 1;
    return m;
  }, {});
console.log('PARTNER_ACTIVITY_MAP', PARTNER_ACTIVITY_MAP);

export default function MapView() {
  const navigate = useNavigate();
  const { session } = useSession();

  const [totalPoints, setTotalPoints] = useState(null);

  useEffect(() => {
    const getPoints = async (_session) => {
      try {
        const queryParams = new URLSearchParams({});
        queryParams.append('userId', _session.id);
        const url = `/sessions/aggregate?${queryParams.toString()}`;

        const res = await getWithAuth(url, _session.authToken);
        const data = await res.json();
        if (!res.ok) {
          throw new Error(data?.message || 'Request failed');
        }
        
        const count = data.filter(entry => PARTNER_ACTIVITY_MAP[entry.activity]).length;
        setTotalPoints(count);
      } catch (error) {
        setTotalPoints(0);
      }
    }

    if (!session) {
      navigate('/');
    } else {
      getPoints(session);
    }
  }, [session, navigate]);

  return (
    <div className="page">
      <Menu />
      <FPOImage src={FPO_IMAGE} height={125} offset={0} alt="Amazon Ads" isOutlined={FPO_OUTLINE} />
      <FPOImage src={FPO_IMAGE} height={585} offset={-125} alt="Your Star Points" isOutlined={FPO_OUTLINE}>
        <div className='points-container'>
            {totalPoints !== null ?
            <span>
              You've visited{' '}
              <span className="point-total">{totalPoints}</span>
              {' '}of {NUM_PARTNERS} Pit Stops.
            </span>
            :
              <span className="loading">*</span>
            }
        </div>
      </FPOImage>
      <FPOImage src={FPO_IMAGE} height={888} offset={-125 - 585} alt="Your mission" isOutlined={FPO_OUTLINE} />
      <FPOImage src={FPO_IMAGE} height={1010} offset={-125 - 585 - 888} alt="Map" isOutlined={FPO_OUTLINE} />
      <FPOImage src={FPO_IMAGE} height={2900} offset={-125 - 585 - 888 - 1010} alt="Our Partners" isOutlined={FPO_OUTLINE} />
      <FPOImage src={FPO_IMAGE} height={450} offset={-125 - 585 - 888 - 1010 - 2900} alt="Amazon Ads, Copyright 2015-2025 Amazon" isOutlined={FPO_OUTLINE} />
    </div>
  );
}